// @ts-strict-ignore
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { getNextFormulaIdentifier } from '@/hybrid/formula/formula.utilities';
import { FormulaEditorParam } from '@/hybrid/formula/FormulaParametersTable.molecule';
import { FormElement } from '@/hybrid/formbuilder/formBuilder.module';
import { ToolPanelFormBuilder } from '@/hybrid/formbuilder/ToolPanelFormBuilder.page';
import _ from 'lodash';

interface AddFormulaParameterModalProps {
  onClose: () => void;
  testId: string;
  parameter?: FormulaEditorParam;
  parameters: FormulaEditorParam[];
  onSave: (item: FormulaEditorParam, original?: FormulaEditorParam) => void;
}

export const AddFormulaParameterModal: React.FunctionComponent<AddFormulaParameterModalProps> = ({
  testId,
  onClose,
  onSave,
  parameters,
  parameter,
}) => {
  const { t } = useTranslation();
  const SEARCH_TYPES = ['Asset', 'Condition', 'Signal', 'CalculatedScalar'];
  const emptyItem = { name: '', id: '' };
  const [parameterIdentifier, setParameterIdentifier] = useState(parameter?.identifier ?? '');
  const [item, setItem] = useState(parameter?.item ?? emptyItem);

  useEffect(() => {
    if (!parameterIdentifier) {
      setParameterIdentifier(getNextFormulaIdentifier(parameters));
    }
  }, []);

  const onSaveCallback = () => {
    if (item.id) {
      onSave(
        {
          ...parameter,
          name: parameterIdentifier,
          item,
          identifier: parameterIdentifier,
        },
        { ...parameter, name: parameter?.name ?? parameter?.identifier },
      );
      onClose();
    }
  };

  const formDataSetup: FormElement[] = [
    {
      component: 'FormControlFormComponent',
      label: 'FORMULA.VARIABLE_IDENTIFIER',
      name: 'parameterIdentifier',
      id: 'parameterIdentifier',
      value: parameterIdentifier,
      onChange: (value: string) => setParameterIdentifier(value),
      size: 'lg',
      extraClassNames: 'mb15',
    },
    {
      component: 'SearchWidgetFormComponent',
      name: 'parameterIdentifierItem',
      searchTypes: SEARCH_TYPES,
      pane: 'modal',
      allowAssetReplacement: false,
      onSearchItemClick: setItem,
      onCloseClick: () => setItem(emptyItem),
      customErrorText: 'FORMULA.NO_ITEM',
      value: item.name,
      onChange: _.noop,
      searchResultsClassNames: 'max-height-425',
    },
  ];

  return (
    <Modal size="sm" show={true} onHide={onClose} animation={false} data-testid={testId}>
      <Modal.Header closeButton={true}>
        <h3>{t('FORMULA.VARIABLE_DEFINE')}</h3>
      </Modal.Header>
      <Modal.Body>
        <div className="flexRowContainer mt5">
          <ToolPanelFormBuilder
            formDefinition={formDataSetup}
            submitFn={onSaveCallback}
            closeFn={onClose}
            toolId="add-variable"
            submitBtnId="addVariableButton"
            wrapInPanel={false}
            submitBtnLabel="ADD"
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};
